// import SubDistrictJSON from '../../../services/REGION_THA/SubDistrict.json'
// import SubDistrictJSON from '../../../../services/REGION_THA/SubDistrict.json'
// import DistrictJSON from "../../../../services/REGION_THA/District.json"
// import ProvinceJSON from "../../../../services/REGION_THA/Province.json"
import {
  getAllProvince,
  getAllDistricts,
  getAllSubDistricts,
} from "../../../../services/AddressService"

export const fetchProvinces = async () => {
  try {
    const response = await getAllProvince()
    // const data = await response?.json()
    // const data = ProvinceJSON
    const data = response?.status === 200 ? response?.data?.data : []
    return data
  } catch (error) {
    throw new Error("Failed to fetch all provinces name")
  }
}

export const fetchDistricts = async () => {
  try {
    // const response = await fetch('https://raw.githubusercontent.com/kongvut/thai-province-data/master/api_amphure.json');
    // const data = DistrictJSON //response.json();
    const response = await getAllDistricts()
    const data = response?.status === 200 ? response?.data?.data : []
    return data
  } catch (error) {
    throw new Error("Failed to fetch districts")
  }
}

export const fetchSubDistricts = async () => {
  try {
    // const response = await fetch('https://raw.githubusercontent.com/kongvut/thai-province-data/master/api_tambon.json');
    // const data = SubDistrictJSON;
    const response = await getAllSubDistricts()
    const data = response?.status === 200 ? response?.data?.data : []
    return data
  } catch (error) {
    throw new Error("Failed to fetch sub-districts")
  }
}
